// 매물 사진 리사이징 URL 변환.
// 백엔드가 주는 S3 원본 URL(장당 최대 ~2.5MB)을 리사이즈 프록시(img.checkmatekorea.com,
// CloudFront → Lambda listing-thumb) 주소로 바꿔 필요한 폭의 webp만 내려받게 한다.
// 인프라 상세: infra/lambda/listing-thumb/README.md

const RESIZE_BASE = process.env.REACT_APP_LISTING_IMG_BASE;

// Lambda의 ALLOWED_WIDTHS와 동일해야 함 (다른 값을 보내면 Lambda가 스냅함)
export type ListingThumbWidth = 240 | 480 | 800 | 1200;

const S3_HOST_PREFIX = 'housebuddy-bucket.s3';
const LISTING_PATH_PREFIX = '/listing/';

/**
 * @description 매물 S3 원본 URL → 리사이즈 프록시 URL.
 * 매물 버킷 URL이 아니거나 환경변수 미설정 시 원본을 그대로 반환한다 (안전 폴백).
 */
export const getListingThumbUrl = (url: string | undefined | null, width: ListingThumbWidth): string => {
  if (!url || !RESIZE_BASE) return url ?? '';
  try {
    const parsed = new URL(url);
    if (!parsed.hostname.startsWith(S3_HOST_PREFIX) || !parsed.pathname.startsWith(LISTING_PATH_PREFIX)) {
      return url;
    }
    return `${RESIZE_BASE}${parsed.pathname}?w=${width}`;
  } catch {
    return url;
  }
};
